/**
* map JS
* -----------------------------------------------------------------------------
*
* All the JS for the map component.
*/

// VARS that are set in map.php:
// mapLocations - array of objects [{address, city, state, zip, coordinates: {lat, lng}}]
// mapStyle - url string of mapbox studio style link
// mapKey - string of mapbox api key
// map icon can be setup in the map.css .markers class and can be an svg or png or custom text. Sky's the limit. You do more with the .markers element in the addMarkers() function
( function( app ) {
  const COMPONENT = {

    className: 'map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {

    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'map', COMPONENT );
} )( app );
